import {Avatar, AvatarFallback} from "@/components/ui/avatar.tsx";
import {useGlobalStore} from "@/store/store.ts";
import {
    Menubar,
    MenubarContent,
    MenubarItem,
    MenubarMenu,
    MenubarTrigger,
} from "@/components/ui/menubar"
import AuthService from "@/services/auth";
import {Button} from "@/components/ui/button";
import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import StepLoginDialog from "@/components//StepLoginDialog";
import {useState} from "react";
import setImg from "@/assets/home/set.png";
import outImg from "@/assets/home/out.png";
import SettingsDialog from "@/components/SettingsDialog";

import eventBus from "@/utils/eventBus.ts";
import TitlleEidt from '@/assets/title-edit.svg?react'
import './index.css'
import useCounterStore from "@/store";
import {HoverTip} from "@/components/hoverTip";
import {PlusIcon} from "@heroicons/react/16/solid";
import {Separator} from "@/components/ui/separator.tsx";
import SidebarSvg from "@/assets/home/sidebar.svg?react";
import { useTranslation } from '@/locales';


interface headerProps {
    title?: string;
    isShare?: boolean;
    onSelect?: () => void
}


const TopicHeader = ({title, isShare = false, onSelect}: headerProps) => {
    const { t } = useTranslation();
    const [loginOpen, setLoginOpen] = useState(false);
    const navigate = useNavigate();


    // const info = AuthService.getUserInfo();
    return (
        <div>
            <div className="header dark:bg-[#1d1d1d] bg-[#ffffff]">
                <div className='text-left  title text-[14px] font-medium text-[#09090B]'
                >
                    <div className={'text-s-color-text-primary s-font-small-strong box-border'}>
                        <h4
                            className='px-[4px] w-fit text-[var(--yb-md-h-color)] max-w-full flex items-center justify-start rounded-[4px] select-none hover:u-hover-show-parent-CigIit'>
                            {title ?? ''}
                        </h4>
                    </div>
                    <div className="px-[4px] text-[10px] text-[#A6A6A6]">
                        {t('common.ai_generated_content')}
                    </div>
                </div>

            </div>


        </div>
    )
}

export default TopicHeader
